module.exports = __webpack_public_path__ + "static/media/Swim.179dc63b.svg";